// extracted by mini-css-extract-plugin
export var banner = "_qo-0";
export var settingRow = "_qo-2";
export var titleIcon = "_qo-1";